import { render, staticRenderFns } from "./string-field.vue?vue&type=template&id=688966e2&"
import script from "./string-field.vue?vue&type=script&lang=ts&"
export * from "./string-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports